export default {
  pt: {
    programDetails: "Detalhes do programa de Seguros {brand}",
  },
  en: {
    programDetails: "Insurance program details {brand}",
  },
}; 